
(function() {
  var wrap = document.getElementById('gg-carousel-wrap');
  var track = document.getElementById('gg-carousel-track');
  var dotsWrap = document.getElementById('gg-dots');
  var cards = track.children;
  var current = 0;
  var gap = 20;

  function perPage() {
    return wrap.offsetWidth > 768 ? 3 : 1;
  }

  function totalPages() {
    return Math.ceil(cards.length / perPage());
  }

  function sizeCards() {
    var pp = perPage();
    var wrapW = wrap.offsetWidth;
    var w;
    if (pp === 1) {
      w = wrapW - 40;
    } else {
      w = (wrapW - gap * (pp - 1)) / pp;
    }
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.width = w + 'px';
      cards[i].style.marginRight = (i < cards.length - 1) ? gap + 'px' : '0px';
    }
  }

  function buildDots() {
    dotsWrap.innerHTML = '';
    var tp = totalPages();
    for (var i = 0; i < tp; i++) {
      var dot = document.createElement('button');
      dot.className = 'gg-dot' + (i === current ? ' active' : '');
      dot.setAttribute('data-i', i);
      dot.addEventListener('click', function() { goTo(parseInt(this.getAttribute('data-i'))); });
      dotsWrap.appendChild(dot);
    }
  }

  function goTo(page) {
    var tp = totalPages();
    current = Math.max(0, Math.min(page, tp - 1));
    var pp = perPage();
    var cardW;
    if (pp === 1) {
      cardW = (wrap.offsetWidth - 40) + gap;
    } else {
      cardW = (wrap.offsetWidth - gap * (pp - 1)) / pp + gap;
    }
    var offset = current * pp * cardW;
    var maxOffset = (cards.length * cardW) - wrap.offsetWidth;
    offset = Math.min(offset, Math.max(0, maxOffset));
    track.style.transform = 'translateX(-' + offset + 'px)';
    var dots = dotsWrap.children;
    for (var i = 0; i < dots.length; i++) {
      dots[i].className = 'gg-dot' + (i === current ? ' active' : '');
    }
  }

  function init() {
    current = 0;
    sizeCards();
    buildDots();
    goTo(0);
  }

  document.getElementById('gg-prev').addEventListener('click', function() { goTo(current - 1); });
  document.getElementById('gg-next').addEventListener('click', function() { goTo(current + 1); });

  init();
  window.addEventListener('resize', init);
})();
